import { WorkspaceList } from "src/context/api/workspaces";

export interface AppSettingsState {
    currentWorkspace: WorkspaceList | null;
}

export const initialState: AppSettingsState = {
    currentWorkspace: null,
};